import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import styles from './LogoCollection.module.css';

const platforms = [
  'Tradelocker',
  'cTrader',
  'Metatrader 5',
  'Tradovate',
  'TopStepX',
  'Ninjatrader'
];

export default function LogoCollection() {
  const [shouldScroll, setShouldScroll] = React.useState(false);
  const containerRef = React.useRef(null);
  const contentRef = React.useRef(null);

  React.useEffect(() => {
    const checkOverflow = () => {
      if (containerRef.current && contentRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        
        // Temporarily force nowrap to measure the actual content width
        const originalFlexWrap = contentRef.current.style.flexWrap;
        contentRef.current.style.flexWrap = 'nowrap';
        const contentWidth = contentRef.current.scrollWidth;
        contentRef.current.style.flexWrap = originalFlexWrap;
        
        setShouldScroll(contentWidth > containerWidth);
      }
    };

    // Use a small delay to ensure layout is settled
    const timer = setTimeout(checkOverflow, 100);
    window.addEventListener('resize', checkOverflow);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', checkOverflow);
    };
  }, []);

  return (
    <Box 
      id="logoCollection" 
      sx={{ 
        position: 'relative',
        py: 4, 
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        mb: 6,
      }}
    >
      {/* Gradient overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(ellipse at center, transparent 0%, transparent 25%, rgba(0, 0, 0, 0.75) 50%, rgba(0, 0, 0, 1) 100%)',
          pointerEvents: 'none',
          zIndex: 1
        }}
      />
      
      <Typography
        component="p"
        variant="subtitle2"
        align="center"
        sx={{ 
          color: '#616161',
          fontSize: '1.1rem',
          fontWeight: 400,
          mb: -1,
          position: 'relative',
          zIndex: 0
        }}
      >
        Import your trades from
      </Typography>
      
      <Box 
        ref={containerRef}
        sx={{ 
          width: '100%',
          maxWidth: '900px',
          position: 'relative',
          zIndex: 0,
          overflow: 'hidden'
        }}
      >
        <Box 
          ref={contentRef}
          className={shouldScroll ? styles.scrollContainer : ''}
          sx={{ 
            display: 'flex',
            flexWrap: shouldScroll ? 'nowrap' : 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: 2, sm: 3, md: 4 },
          }}
        >
          {(shouldScroll ? [...platforms, ...platforms] : platforms).map((platform, index) => (
            <Typography
              key={index}
              sx={{
                color: 'white', 
                fontSize: { xs: '0.95rem', sm: '1rem', md: '1.1rem' },
                fontWeight: 350,
                transition: 'color 0.2s ease',
                whiteSpace: 'nowrap',
                '&:hover': {
                  color: 'white'
                }
              }}
            >
              {platform}
            </Typography>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
